"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configure = exports.globalConfig = void 0;

var _AddressService = _interopRequireDefault(require("./services/AddressService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var globalConfig = {
  addressService: _AddressService.default
};
exports.globalConfig = globalConfig;

var configure = function configure(options) {
  if (_typeof(options) !== 'object') {
    return;
  }

  for (var key in options) {
    if (options.hasOwnProperty(key)) {
      globalConfig[key] = options[key];
    }
  }
};

exports.configure = configure;
var _default = {
  configure: configure,
  globalConfig: globalConfig
};
exports.default = _default;
//# sourceMappingURL=index.js.map